<div class="home">
  <img class="home_logo" [src]="logoUrl$ | async">
</div>
